import { type SvgProps, SvgWrapper } from '../utils';

export function RowsIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M20.25 15.75H3.75V19C3.75 19.6904 4.30964 20.25 5 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V15.75ZM3.75 14.25H20.25V9.75H3.75V14.25ZM20.25 5C20.25 4.30964 19.6904 3.75 19 3.75H5C4.30964 3.75 3.75 4.30964 3.75 5V8.25H20.25V5ZM21.75 19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5C2.25 3.48122 3.48122 2.25 5 2.25H19C20.5188 2.25 21.75 3.48122 21.75 5V19Z" />
    </SvgWrapper>
  );
}
